import { render, staticRenderFns } from "./Quotation.vue?vue&type=template&id=6757251a&scoped=true&"
import script from "./Quotation.vue?vue&type=script&lang=js&"
export * from "./Quotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6757251a",
  null
  
)

export default component.exports